import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';



const Chipas = ({ filtrai, removeChip, className }) => {
    const [chipai, setChipai] = useState([])
    const { t } = useTranslation()

    useEffect(() => {
        let chipukai = []

        Object.keys(filtrai).forEach((group) => {
            filtrai[group].forEach(
                (value) => {
                    chipukai.push({ group, value })
                }
            )
        })

        setChipai(chipukai)
    }, [filtrai]);

    return (
        <Stack className={className} direction="row" spacing={1}>
            {
                chipai.length > 0 ?
                    chipai.map(({ value, group }) =>
                    (
                        <Chip
                            className='chip'
                            key={group + value}
                            label={`${t(group)}: ${t(value) || t(value.charAt(0).toUpperCase() + value.slice(1))}`}
                            variant={'outlined'}
                            onDelete={() => { removeChip(group, value) }}
                        />
                    ))
                    : ''
            }
        </Stack>
    );
}
export default Chipas